const UserRole = {
  SuperAdmin: 'supar-admin',
  Admin: 'admin',
  Staff: 'staff',
  Maker: 'maker',
  Approver: 'approver'
};

export default UserRole;
